import React, {useEffect, useState} from 'react'
import Search from "antd/lib/input/Search"
import {useBlackListContext} from "../store/useBlackListContext"

const BlackListSearch = () => {

    const [inputValue, setInputValue] = useState('')

    useEffect(() => {
        const timer = setTimeout(() => {
            onSearchChange(inputValue)
        }, 500)

        return () => {
            clearTimeout(timer)
        }

    }, [inputValue])


    const {onSearchChange} = useBlackListContext()

    return (
        <div>
            <Search
                placeholder="请输入搜索内容"
                onSearch={value => onSearchChange(value)}
                onChange={e => setInputValue(e.target.value)}
                style={{width: 200}}
            />
        </div>
    )
}

export default BlackListSearch


// WEBPACK FOOTER //
// ./src/containers/ClubBlacklist/component/BlackListSearch.js